import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldCheck, LogOut, LayoutDashboard, Settings, User } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-8 h-8 rounded-md bg-slate-900 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5 text-amber-500" />
          </div>
          <span className="font-display font-bold text-slate-900 tracking-tight hidden sm:block">
            High-Ticket Blueprint
          </span>
        </Link>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin-btn">
                  <Settings className="w-4 h-4 mr-1.5" /> Admin
                </Button>
              )}
              <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-btn">
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Button>
              <Button variant="ghost" size="sm" onClick={() => navigate("/profile")} data-testid="nav-profile-btn">
                <User className="w-4 h-4 mr-1.5" /> Profile
              </Button>
              <Button variant="outline" size="sm" onClick={doLogout} data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4 mr-1.5" /> Log out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                Log in
              </Button>
              <Button size="sm" className="bg-slate-900 hover:bg-slate-800" onClick={() => navigate("/register")} data-testid="nav-register-btn">
                Get access
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
